module.exports = __webpack_public_path__ + "static/media/ng.b00baa3c.jpg";